export default __webpack_public_path__ + "static/media/as-1.cec1b3ff.png";